define("media/components/media/label-media", ["exports", "@ember/component", "ember-concurrency/async-arrow-runtime", "@ember/service", "@ember/utils", "@glimmer/component", "@glimmer/tracking", "ember-concurrency", "tracked-built-ins", "later/lib/filter-by-fields", "@ember/template-factory"], function (_exports, _component, _asyncArrowRuntime, _service, _utils, _component2, _tracking, _emberConcurrency, _trackedBuiltIns, _filterByFields, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"ember-cli-htmlbars",0,"@ember/service",0,"@ember/utils",0,"@glimmer/component",0,"@glimmer/tracking",0,"ember-concurrency",0,"tracked-built-ins",0,"later/lib/filter-by-fields",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <label data-test-id="label">
    {{svg-jar "label" class="o--icon u--m__r"}}
    {{t "media_items.labels.title"}}
  </label>
  <a class="u--m__l__sm u--text--sm u--text--uppercase e--label__trigger">
    {{t "shared_words.add"}}
  </a>
  
  {{#if this.mediaItemLabels.length}}
    <div class="cLB--labelWrapper u--clearfix u--p__l__lg" data-test-id="label-list">
      {{#each this.mediaItemLabels as |itemLabel|}}
        <span class="cLB--label {{if itemLabel.isSystemLabel 'cLB--label--system'}}" data-test-id="label-list-item">
          <span class="cLB--label__text">
            {{itemLabel.canonicalTagName}}
          </span>
          {{#unless itemLabel.isSystemLabel}}
            <span {{on "click" (perform this.updateLabel itemLabel)}}>
              {{svg-jar "close" class="o--icon o--icon--light cLB--label__icon"}}
            </span>
          {{/unless}}
        </span>
      {{/each}}
    </div>
  {{/if}}
  <Shared::Ui::EmberDrop
    @classes="o--dropWrapper__label"
    @constrainToScrollParent={{true}}
    @constrainToWindow={{false}}
    @contentSelector=".e--label__drop"
    @position="top left"
    @target=".e--label__trigger"
    as |emberDrop|
  >
    <div class="o--dropWrapper--md e--label__drop">
      <div class="o--dropHeader">
        <h4 class="o--dropHeader__title">
          {{t "media_items.labels.title"}}
        </h4>
        <span class="o--dropHeader__close" {{on "click" emberDrop.closeAction}}>
          {{svg-jar "close" class="o--icon--sm o--icon--light"}}
        </span>
        {{#if @groupLabels.length}}
          <div class="cLB--drop__searchWrapper">
            {{svg-jar "search" class="o--icon o--icon--light"}}
            <Input
              @type="search"
              @value={{this.searchString}}
              autofocus={{true}}
              class="o--form__input o--form__input--mute"
              placeholder={{t "media_items.labels.search_labels"}}
            />
          </div>
        {{/if}}
      </div>
      <div class="o--dropBody--scroll eLB--dropBody">
        <ul class="o--dropBody__list cLB--dropBody__list">
          {{#each this.filteredGroupLabels as |groupLabel|}}
            <Media::LabelMediaItem
              @deleteLabel={{@deleteLabel}}
              @label={{groupLabel}}
              @mediaLabels={{this.mediaItemLabels}}
              @updateLabel={{perform this.updateLabel}}
            />
          {{/each}}
        </ul>
      </div>
      <div class="o--dropFooter eLB--dropFooter">
        <div class="cLB--drop__inputWrapper">
          <Input
            @enter={{perform this.addNewLabel}}
            @type="text"
            class="o--form__input eLB--drop__input is--focus"
            placeholder={{t "media_items.labels.add_new_label"}}
          />
          <span {{on "click" (perform this.addNewLabel)}}>
            {{svg-jar "add-circle" class="o--icon o--inputAction__icon--right u--text--hl"}}
          </span>
        </div>
      </div>
    </div>
  </Shared::Ui::EmberDrop>
  */
  {
    "id": "zpa5lqha",
    "block": "[[[10,\"label\"],[14,\"data-test-id\",\"label\"],[12],[1,\"\\n  \"],[1,[28,[35,0],[\"label\"],[[\"class\"],[\"o--icon u--m__r\"]]]],[1,\"\\n  \"],[1,[28,[35,1],[\"media_items.labels.title\"],null]],[1,\"\\n\"],[13],[1,\"\\n\"],[10,3],[14,0,\"u--m__l__sm u--text--sm u--text--uppercase e--label__trigger\"],[12],[1,\"\\n  \"],[1,[28,[35,1],[\"shared_words.add\"],null]],[1,\"\\n\"],[13],[1,\"\\n\\n\"],[41,[30,0,[\"mediaItemLabels\",\"length\"]],[[[1,\"  \"],[10,0],[14,0,\"cLB--labelWrapper u--clearfix u--p__l__lg\"],[14,\"data-test-id\",\"label-list\"],[12],[1,\"\\n\"],[42,[28,[37,4],[[28,[37,4],[[30,0,[\"mediaItemLabels\"]]],null]],null],null,[[[1,\"      \"],[10,1],[15,0,[29,[\"cLB--label \",[52,[30,1,[\"isSystemLabel\"]],\"cLB--label--system\"]]]],[14,\"data-test-id\",\"label-list-item\"],[12],[1,\"\\n        \"],[10,1],[14,0,\"cLB--label__text\"],[12],[1,\"\\n          \"],[1,[30,1,[\"canonicalTagName\"]]],[1,\"\\n        \"],[13],[1,\"\\n\"],[41,[51,[30,1,[\"isSystemLabel\"]]],[[[1,\"          \"],[11,1],[4,[38,6],[\"click\",[28,[37,7],[[30,0,[\"updateLabel\"]],[30,1]],null]],null],[12],[1,\"\\n            \"],[1,[28,[35,0],[\"close\"],[[\"class\"],[\"o--icon o--icon--light cLB--label__icon\"]]]],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]],null],[1,\"      \"],[13],[1,\"\\n\"]],[1]],null],[1,\"  \"],[13],[1,\"\\n\"]],[]],null],[8,[39,8],null,[[\"@classes\",\"@constrainToScrollParent\",\"@constrainToWindow\",\"@contentSelector\",\"@position\",\"@target\"],[\"o--dropWrapper__label\",true,false,\".e--label__drop\",\"top left\",\".e--label__trigger\"]],[[\"default\"],[[[[1,\"\\n  \"],[10,0],[14,0,\"o--dropWrapper--md e--label__drop\"],[12],[1,\"\\n    \"],[10,0],[14,0,\"o--dropHeader\"],[12],[1,\"\\n      \"],[10,\"h4\"],[14,0,\"o--dropHeader__title\"],[12],[1,\"\\n        \"],[1,[28,[35,1],[\"media_items.labels.title\"],null]],[1,\"\\n      \"],[13],[1,\"\\n      \"],[11,1],[24,0,\"o--dropHeader__close\"],[4,[38,6],[\"click\",[30,2,[\"closeAction\"]]],null],[12],[1,\"\\n        \"],[1,[28,[35,0],[\"close\"],[[\"class\"],[\"o--icon--sm o--icon--light\"]]]],[1,\"\\n      \"],[13],[1,\"\\n\"],[41,[30,3,[\"length\"]],[[[1,\"        \"],[10,0],[14,0,\"cLB--drop__searchWrapper\"],[12],[1,\"\\n          \"],[1,[28,[35,0],[\"search\"],[[\"class\"],[\"o--icon o--icon--light\"]]]],[1,\"\\n          \"],[8,[39,9],[[16,\"autofocus\",true],[24,0,\"o--form__input o--form__input--mute\"],[16,\"placeholder\",[28,[37,1],[\"media_items.labels.search_labels\"],null]]],[[\"@type\",\"@value\"],[\"search\",[30,0,[\"searchString\"]]]],null],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],null],[1,\"    \"],[13],[1,\"\\n    \"],[10,0],[14,0,\"o--dropBody--scroll eLB--dropBody\"],[12],[1,\"\\n      \"],[10,\"ul\"],[14,0,\"o--dropBody__list cLB--dropBody__list\"],[12],[1,\"\\n\"],[42,[28,[37,4],[[28,[37,4],[[30,0,[\"filteredGroupLabels\"]]],null]],null],null,[[[1,\"          \"],[8,[39,10],null,[[\"@deleteLabel\",\"@label\",\"@mediaLabels\",\"@updateLabel\"],[[30,5],[30,4],[30,0,[\"mediaItemLabels\"]],[28,[37,7],[[30,0,[\"updateLabel\"]]],null]]],null],[1,\"\\n\"]],[4]],null],[1,\"      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n    \"],[10,0],[14,0,\"o--dropFooter eLB--dropFooter\"],[12],[1,\"\\n      \"],[10,0],[14,0,\"cLB--drop__inputWrapper\"],[12],[1,\"\\n        \"],[8,[39,9],[[24,0,\"o--form__input eLB--drop__input is--focus\"],[16,\"placeholder\",[28,[37,1],[\"media_items.labels.add_new_label\"],null]]],[[\"@enter\",\"@type\"],[[28,[37,7],[[30,0,[\"addNewLabel\"]]],null],\"text\"]],null],[1,\"\\n        \"],[11,1],[4,[38,6],[\"click\",[28,[37,7],[[30,0,[\"addNewLabel\"]]],null]],null],[12],[1,\"\\n          \"],[1,[28,[35,0],[\"add-circle\"],[[\"class\"],[\"o--icon o--inputAction__icon--right u--text--hl\"]]]],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"]],[2]]]]]],[\"itemLabel\",\"emberDrop\",\"@groupLabels\",\"groupLabel\",\"@deleteLabel\"],false,[\"svg-jar\",\"t\",\"if\",\"each\",\"-track-array\",\"unless\",\"on\",\"perform\",\"shared/ui/ember-drop\",\"input\",\"media/label-media-item\"]]",
    "moduleName": "media/components/media/label-media.hbs",
    "isStrictMode": false
  });
  let LabelMediaComponent = _exports.default = (_class = class LabelMediaComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "alerts", _descriptor, this);
      _initializerDefineProperty(this, "errors", _descriptor2, this);
      _initializerDefineProperty(this, "intl", _descriptor3, this);
      _initializerDefineProperty(this, "segment", _descriptor4, this);
      _initializerDefineProperty(this, "searchString", _descriptor5, this);
      _defineProperty(this, "updateLabel", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* (label) {
          const {
            mediaItem,
            location
          } = this.args;
          if (mediaItem.labels.includes(label)) {
            mediaItem.labels.removeObject(label);
            label.decreaseTaggedCount();
          } else {
            mediaItem.labels.addObject(label);
            label.increaseTaggedCount();
            this.segment.track('labelled-media', {
              image_url: mediaItem.imageUrl,
              video_url: mediaItem.videoUrl,
              label: label.canonicalTagName,
              location
            });
          }
          try {
            yield mediaItem.save();
          } catch (adapterError) {
            this.errors.handleAdapter(adapterError, this.args.mediaItem);
          }
        }
      }), null, "updateLabel", "drop"));
      _defineProperty(this, "addNewLabel", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          const dropInput = document.querySelector('.eLB--drop__input');
          if (dropInput === null) return;
          const newLabel = dropInput.value;
          const createdFromLabelMedia = true;
          if ((0, _utils.isPresent)(newLabel)) {
            try {
              const labelsProxy = yield this.args.mediaItem.labels;
              const labels = new _trackedBuiltIns.TrackedArray(labelsProxy.toArray());
              yield this.args.addNewLabel.perform(newLabel, labels, createdFromLabelMedia);
              const dropBody = document.querySelector('.eLB--dropBody');
              dropBody.scrollTop = dropBody.scrollHeight;
              dropInput.value = '';
            } catch (error) {
              this.alerts.alert(this.intl.t('alerts.media_items.labels.create_label_error'));
              this.errors.log(error);
            }
          }
        }
      }), null, "addNewLabel", null));
    }
    get filteredGroupLabels() {
      if ((0, _utils.isEmpty)(this.searchString)) {
        return this.nonSystemLabels;
      }
      if (!this.nonSystemLabels) {
        return;
      }
      return (0, _filterByFields.default)(this.nonSystemLabels, ['tagName'], this.searchString);
    }
    get mediaItemLabels() {
      return this.args.mediaItem.labels;
    }
    get nonSystemLabels() {
      return this.args.groupLabels?.filter(label => label.isSystemLabel === false) || [];
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "searchString", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, LabelMediaComponent);
});